import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Loading from '../general/Loading';

const AddCoupon = ({setResponse}) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    code: '',
    discount_type: '', // 'amount' or 'percent'
    amount: '',
    orderValue: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await fetch('https://api.siddhabhairabistore.com/add-coupon', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const data = await res.json();

      if (!res.ok) throw new Error(data.message || 'Failed to add coupon');
      setResponse({ message: 'Coupon Added successfully.', status: 'success' });
      setTimeout(() => setResponse(''), 2000);
      navigate('/added-coupons');
    } catch (err) {
      setResponse({ message: 'Failed to add coupon.', status: 'error' });
      setTimeout(() => setResponse(''), 2000);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <section className='my-4'>
        <div className='px-4'>
          <div className='d-flex justify-content-between'>
            <p className='page-title'>Add New Coupon</p>
            <button className='close-btn' onClick={() => navigate('/added-coupons')}>Go Back</button>
          </div>

          <form onSubmit={handleSubmit} className='row g-3 bg-white rounded-2 mt-3'>

            <div className='col-md-6'>
              <label className="profile-label">Coupon Name</label>
              <input
                type='text'
                name='name'
                value={formData.name}
                onChange={handleChange}
                className='product-control'
                required
              />
            </div>

            <div className='col-md-6'>
              <label className="profile-label">Coupon Code</label>
              <input
                type='text'
                name='code'
                value={formData.code}
                onChange={handleChange}
                className='product-control'
                required
              />
            </div>

            <div className='col-md-6'>
              <label className="profile-label">Discount Type</label>
              <select
                name='discount_type'
                value={formData.discount_type}
                onChange={handleChange}
                className='product-control'
                required
              >
                <option value=''>-- Choose --</option>
                <option value='amount'>Amount</option>
                <option value='percent'>Percent</option>
              </select>
            </div>

            <div className='col-md-6'>
              <label className="profile-label">Discount Amount</label>
              <input
                type='number'
                name='amount'
                value={formData.amount}
                onChange={handleChange}
                className='product-control'
                required
              />
            </div>

            <div className='col-md-6'>
              <label className="profile-label">Min Order Value</label>
              <input
                type='number'
                name='orderValue'
                value={formData.orderValue}
                onChange={handleChange}
                className='product-control'
              />
            </div>

            <div className="col-12 text-end">
              <button type="submit" className="edit-btn">
                Submit Now
              </button>
            </div>
            
          </form>
        </div>
      </section>

      {loading && <Loading setLoading={setLoading} />}
    </>
  );
};

export default AddCoupon;
